import { useContext } from 'react';
import { Link } from 'react-router-dom';

import styles from './Magazines.module.css';

import { Loading } from '../../../../../components/loading/Loading';

import { Issue } from '../../../../../constants';
import { useGetIssues } from '../Sections.hooks';

import { TrackingContext } from '../../../../../tracking/Tracking.context';

const SECTION_ID = 14;

export function Magazines() {
	const { isLoading, issues, error } = useGetIssues(SECTION_ID);
	if (isLoading) {
		return (
			<div style={{ height: '100%' }}>
				<Loading />
			</div>
		);
	}
	if (error) {
		return <div>{error.message}</div>;
	}

	return (
		<section className={styles['magazines']}>
			<IssuesContainer issues={issues} />
		</section>
	);
}

function IssuesContainer({ issues }: IssuesProps) {
	if (!issues) {
		return null;
	}
	const latestIssue = issues[0];
	return (
		<div className={styles['issues-container']}>
			<div>{latestIssue ? <LatestIssue {...latestIssue} /> : null}</div>
			<div>
				<Issues issues={issues} />
			</div>
		</div>
	);
}

interface IssuesProps {
	issues: Array<Issue>;
}

function LatestIssue(issue: Issue) {
	const { sendEvent } = useContext(TrackingContext);
	const { id, name, cover, description, slug } = issue;
	const url = `/preview/${slug ? slug : id}`;
	const from = window.location.pathname;

	return (
		<div className={styles['latest-issue']}>
			<Link
				to={url}
				state={{ from }}
				onClick={() => {
					sendEvent({
						type: 'BTN_CLICK_ISSUE',
						data: {
							issue: {
								id: parseInt(`${issue.id}`, 10),
								slug: issue.slug,
							},
						},
					});
				}}
			>
				<figure role="button" style={{ cursor: 'pointer' }}>
					<img src={cover} alt={`${name} - Cover`} width={340} />
				</figure>
			</Link>
			<div className={styles['title']}>
				<h1>{name}</h1>
				{description ? <p>{description}</p> : null}
			</div>
		</div>
	);
}

function Issues({ issues }: IssuesProps) {
	return (
		<div className={styles['issues']}>
			{issues.map((issue) => (
				<IssueComponent key={issue.id} {...issue} />
			))}
		</div>
	);
}

const IssueComponent = (issue: Issue) => {
	const { sendEvent } = useContext(TrackingContext);
	const { id, name, description, cover, slug } = issue;
	const url = `/preview/${slug ? slug : id}`;
	const from = `${window.location.pathname}?section=issues`;
	return (
		<div className={styles['issue']}>
			<div>
				<Link
					to={url}
					state={{ from }}
					onClick={() => {
						sendEvent({
							type: 'BTN_CLICK_ISSUE',
							data: {
								issue: {
									id: parseInt(`${issue.id}`, 10),
									slug: issue.slug,
								},
							},
						});
					}}
				>
					<figure role="button" style={{ cursor: 'pointer' }}>
						<img src={cover} alt={`${name} - cover`} width={340} />
					</figure>
				</Link>
			</div>
			<div>
				<h4>{name}</h4>
				<p>{description}</p>
			</div>
		</div>
	);
};
